import type { Tab, LayoutType } from 'types';
import type { TemplateFormsState } from '../index';
import { getUsedTabs, hasUniqueTabNames } from '../utils/nameUniqueness';

interface Payload {
  layoutType: LayoutType;
  tab: Tab;
}

export const addTab = (state: TemplateFormsState, { payload }: { payload: Payload }) => {
  const { layoutType, tab } = payload;
  if (state[layoutType].tabs.some((t) => t.id === tab.id)) return;

  const visibleTabs = getUsedTabs(state[layoutType].tabs, state[layoutType].sections);

  if (!hasUniqueTabNames(visibleTabs, tab)) {
    throw new Error('tabExists');
  }

  state[layoutType].tabs.push(tab);
};
